// extracted by mini-css-extract-plugin
export var active = "content-module--active--10646";
export var article = "content-module--article--63662";
export var aside = "content-module--aside--eec14";
export var blogRow = "content-module--blogRow--d5da7";
export var blog__content = "content-module--blog__content--514e1";
export var blog__content__audio = "content-module--blog__content__audio--e7a65";
export var blog__content__author = "content-module--blog__content__author--2d184";
export var blog__content__author__img = "content-module--blog__content__author__img--1a6cd";
export var blog__content__author__name = "content-module--blog__content__author__name--2a425";
export var blog__content__container = "content-module--blog__content__container--9bf90";
export var blog__content__container__new = "content-module--blog__content__container__new--dce45";
export var blog__content__description = "content-module--blog__content__description--ee633";
export var blog__content__meta = "content-module--blog__content__meta--55ca8";
export var blog__content__meta__details = "content-module--blog__content__meta__details--a6b8a";
export var blog__social__icons = "content-module--blog__social__icons--d3e78";
export var blog__social__item = "content-module--blog__social__item--a965f";
export var blog__social__link = "content-module--blog__social__link--32eb4";
export var blog__social__share = "content-module--blog__social__share--a89a1";
export var blog_contact_section = "content-module--blog_contact_section--8e1fd";
export var blog_main_article = "content-module--blog_main_article--cb778";
export var description = "content-module--description--57243";
export var emailArea = "content-module--emailArea--578d7";
export var envelope = "content-module--envelope--d04de";
export var error = "content-module--error--92d86";
export var errortxt = "content-module--errortxt--9da33";
export var facebook = "content-module--facebook--4e988";
export var formArea = "content-module--formArea--0a38f";
export var formGroup = "content-module--formGroup--28546";
export var linkedIn = "content-module--linkedIn--5d9f9";
export var recent_blog_container = "content-module--recent_blog_container--a3a5a";
export var recent_blog_section = "content-module--recent_blog_section--f423d";
export var research_content = "content-module--research_content--995af";
export var search_form = "content-module--search_form--0742c";
export var submitButton = "content-module--submitButton--2faca";
export var successMessage = "content-module--successMessage--27bbf";
export var table_content = "content-module--table_content--e25c6";
export var table_of_data_section = "content-module--table_of_data_section--09ea2";
export var tocRevealLinker = "content-module--tocRevealLinker--602a7";
export var tocRevealLinker__icon = "content-module--tocRevealLinker__icon--a81c4";
export var twitter = "content-module--twitter--f190c";
export var verifiedemail = "content-module--verifiedemail--636bc";